<template>
<div>
     <v-timeline
    align-top
  >
    <v-timeline-item
      v-for="(post, i) in posts"
      :key="i"
      color="red lighten-2"
      icon="mdi-calendar-clock"
      fill-dot
    >
    <span class="caption" slot="opposite"><v-icon>mdi-account</v-icon> {{post.user}} sur <b>{{post.Cont_Nom}}</b><br><v-icon>mdi-clock</v-icon>{{post.posphto_time}}<br><v-icon v-if="post.posphto_cmt.length!==0">mdi-comment-outline</v-icon>{{post.posphto_cmt}}</span>
      <v-card

         class="elevation-2"
      >
        <v-card-text class="white text--primary">
          <v-img
            :lazy-src="post.posphto_Url"
            max-height="150"
            max-width="250"
            :src="post.posphto_Url"
            @click="showpic(post)"
          ></v-img>

        </v-card-text>
      </v-card>
    </v-timeline-item>
  </v-timeline>

        <h1 v-if="posts.length===0">Album vide</h1>

            <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >

      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          ><v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-img :src="currentPic.posphto_Url"></v-img>

          <h1>{{currentPic.Cont_Nom}}</h1>
          <v-chip> {{currentPic.posphto_time}}</v-chip>
          <v-card-text>
            {{currentPic.posphto_cmt}}
          </v-card-text>
      </v-card></v-dialog>

</div>
</template>

<script>
import { minuAPI } from '../services/http-common'
import * as fb from '../firebase'
import Swal from 'sweetalert2'

export default {
  data () {
    return {
      posts: [],
      errors: [],
      dialog: false,
      currentPic: ''
    }
  },

  // Fetches posts when the component is created.
  created: function () {
    this.loade()
  },

  methods: {
    detail (data) {
      Swal.fire({
        title: data.Cont_Nom,
        button: 'ok',
        text: 'prise le ' + data.posphto_time
      })
    },
    showpic (post) {
      this.dialog = true
      this.currentPic = post
    },
    loade () {
      minuAPI.post(`liste.php`, {'email': fb.auth.currentUser.email})
        .then(response => {
          this.posts = response.data
          console.log(response.data) // properties
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ListePhoto.vue